<div class="border-card-no-scroll">
    <div [ngClass]="{'border': border }" class="header-card">
        <div class="title-container">
            <h2 class="title-card">{{title}}</h2>
            <h3 #subtitleColorRef class="subtitle-card">{{subtitle}}</h3>
        </div>
        <div class="icons-card">
            <button #emptyIconRef *ngIf="emptyIcon" class="empty-button" (click)=active()>
                <frg-inline-svg [fill]="emptyIcon.fill" [stroke]="emptyIcon.stroke" [src]="emptyIcon.src">
                </frg-inline-svg>
            </button>
            <button #fullIconRef *ngIf="fullIcon" class="full-button" (click)=active()>
                <frg-inline-svg class="icon" [fill]="fullIcon.fill" [stroke]="fullIcon.stroke" [src]="fullIcon.src">
                </frg-inline-svg>
            </button>
        </div>
    </div>
    <div class="body-card">
        <ng-content></ng-content>
    </div>
</div>